(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('shadowItTopByUsers', ["path", "securityEventsDao", "timeResolutions", "verticalPlotLogicCore", "securityEventsLinkGenerator", "routeHelper", function (path, securityEventsDao, timeResolutions, verticalPlotLogicCore, securityEventsLinkGenerator, routeHelper) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('shadow-it/top-by-users').template('top-by-users'),
            scope: {
                saasList: '=',
                resolution: '=',
                eventStates: '='
            },
            link: function ($scope) {
                $scope.model = {
                    wrapper: {},
                    flotOptions: {
                        series: {
                            stack: false,
                            bars: {
                                show: true,
                                horizontal: true,
                                align: 'center',
                                barWidth: 0.3,
                                lineWidth: 0,
                                fill: 1
                            },
                            color: '#2980b9'
                        },
                        grid: {
                            hoverable: true,
                            clickable: true,
                            borderWidth: 1,
                            tickColor: '#fff',
                            borderColor: '#eee',
                            autoHighlight: false
                        },
                        legend: { show: false },
                        yaxis: {
                            labelWidth: 150,
                            axisLabelUseCanvas: false,
                            tickSize: 1
                        },
                        xaxis: { minTickSize: 1 },
                        shadowSize: 0,
                        tooltip: true,
                        tooltipOpts: {
                            defaultTheme: false,
                            content: '%s',
                            shifts: {
                                x: 0,
                                y: 10
                            },
                            onHover: function (event, tooltip) {
                                var left;
                                if (!event.series || !event.series.xaxis) {
                                    left = Math.round(event.pageX - tooltip.width() / 2);
                                } else {
                                    var barHalf = (event.datapoint[0] - event.series.xaxis.datamin) / 2 / (event.series.xaxis.datamax - event.series.xaxis.datamin) * event.series.xaxis.box.width;
                                    left = Math.round(event.pageX - barHalf - tooltip.width() / 2);
                                }
                                tooltip.css('left', left + 'px');
                            }
                        }
                    }
                };
                $scope.plotLogicDestructor = _.noop;
                $scope.widgetApi = {};
                var linkParams = {};
                var noImage = {};
                var missingImages = [
                    'adp',
                    'angusanywhere',
                    'sf-notifications',
                    'trello',
                    'wetransfer',
                    'zendesk'
                ];
                var getMissingImgPath = function (url) {
                    var downCasedUrl = url.toLowerCase();
                    var imgName = _(missingImages).find(function (name) {
                        return downCasedUrl.indexOf(name) !== -1;
                    });
                    if (imgName) {
                        return path('gui-v2').directive('shadow-it').img(imgName + '.png');
                    }
                    return '';
                };
                $scope.loadData = function () {
                    var lines = 10;
                    var resolution = timeResolutions.get($scope.resolution);
                    var promise = securityEventsDao.list().params({
                        groupBy: [
                            'shadow_it_application',
                            'av_category'
                        ].join(','),
                        filterEnum_saas: _($scope.saasList).map(function (saas) {
                            return saas.name;
                        }).join(','),
                        filterEnum_type: 'shadow_it',
                        afterColumn: 'create_time',
                        afterStep: resolution.id,
                        afterFromNow: true,
                        afterMax: 1,
                        limit: lines,
                        sortColumn: 'count',
                        sortDirection: 'desc'
                    });
                    linkParams = {
                        resolution: timeResolutions.get($scope.resolution).id,
                        saas: _($scope.saasList).map(function (saas) {
                            return saas.name;
                        })
                    };
                    if ($scope.eventStates) {
                        promise = promise.params({ filterEnum_current_state: $scope.eventStates.join(',') });
                        linkParams.current_state = $scope.eventStates;
                    }
                    $scope.plotLogicDestructor();
                    $scope.plotLogicDestructor = verticalPlotLogicCore($scope, {
                        noEmptyLines: false,
                        lines: lines
                    }, {
                        idColumn: 'shadow_it_application',
                        countColumn: 'count',
                        makeLabel: function (row) {
                            var generatedId = 'shadow_app_logo_';
                            if (row.shadow_it_application) {
                                generatedId += row.shadow_it_application.replace(/\./g, '_');
                            }
                            $scope.$watch(function () {
                                return angular.element('#' + generatedId) && angular.element('#' + generatedId).length;
                            }, function (newValue, oldValue) {
                                angular.element('#' + generatedId).off('error');
                                angular.element('#' + generatedId).on('error', function () {
                                    if (noImage[generatedId]) {
                                        angular.element(this).hide();
                                    } else {
                                        var imgPath = getMissingImgPath(row.shadow_it_application);
                                        if (imgPath) {
                                            angular.element(this).attr('src', imgPath);
                                            noImage[generatedId] = true;
                                        } else {
                                            angular.element(this).hide();
                                        }
                                    }
                                });
                            });
                            return '<a href="' + linkHref(row) + '" class="chart-row custom-tip">' + '<div class="row-label">' + row.shadow_it_application + '</div>' + '<div class="shadow-app-logo">' + '<img src="//logo.clearbit.com/' + row.shadow_it_application + '" id="' + generatedId + '">' + '</div>' + '<div class="row-count">' + row.count + '</div>' + '<span class="custom-tiptext">' + toolTipContent(row) + '</span>' + '</a>';
                        },
                        retrieve: function () {
                            return promise;
                        },
                        fromBottom: true,
                        makeTooltipContent: toolTipContent,
                        makeLink: linkPath
                    });
                    return promise;
                };
                function linkPath(row) {
                    return securityEventsLinkGenerator.createPath($.extend({ shadow_it_application: [row.shadow_it_application] }, linkParams));
                }
                function linkHref(row) {
                    return routeHelper.pathToHref(linkPath(row));
                }
                function toolTipContent(row) {
                    return row.shadow_it_application + (row.av_category ? ' (' + row.av_category + ')' : '') + ' --- ' + row.count;
                }
                $scope.$watchGroup([
                    'resolution',
                    'saasList',
                    'eventStates'
                ], function () {
                    $scope.widgetApi.reload();
                });
                $scope.$on('$destroy', function () {
                    $scope.plotLogicDestructor();
                });
            }
        };
    }]);
}());